import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  t: "1684203689141",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2379",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M796.928 581.376H246.528a30.72 30.72 0 0 1 0-61.44h550.4a30.72 30.72 0 0 1 0 61.44z",
      fill: "#ffffff",
      "p-id": "2380"
    }, null, -1)
  ]))]))
}
export default { render: render }